import React from 'react'
import { Route } from 'react-router'
import { createReducer } from '@reduxjs/toolkit'
import AdminIndexView from './index_view'
import { builderCallback, initialState } from '../smart_bps/admin/index'
import { AdminModelViewRouter } from './admin_model_view_router'
import UserAdminModelView from './user_admin'
import { AdminListViewRouter } from './admin_list_view_router'


export const reducer = createReducer(initialState, (builder) => {
    builderCallback(builder)
})

export const routes = (
    <Route path="admin">
        <Route index element={<AdminIndexView />} />

        <Route path="User/:object_id" element={<UserAdminModelView />} />

        <Route path=":model_name" element={<AdminListViewRouter />} />
        <Route path=":model_name/:object_id" element={<AdminModelViewRouter />} />
    </Route>
)
